<template>
  <div>
    <info-box v-bind:description="description"></info-box>
    <header-title v-bind:title_img_src="title_img" />
    <nav-bar></nav-bar>
    <br/>
    <slider></slider>
  </div>
</template>

<script>
import slider from './slider'
export default {
  name: 'Home',
  components: {
    slider
  },
  created: function () {
    this.msg = 'WAT'
  },
  data () {
    return {
      title_img: 'swiftorland-title.svg',
      msg: 'Welcome to Your Vue.js App',
      description: {
        title: 'Welcome!',
        text: 'Check on bets, leaderboards, bounties, and lottery ticket purchases. Login with your twitch to get easy access to your info!'
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Home.vue